// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2-vtn","Label":"BuildControl_Label__2C7Uh","Less":"BuildControl_Less__1ZLBe","More":"BuildControl_More__hOpVK"};